/**
 * #http.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../typeRegistry.js";
function createBaseFetchRequest() {
    return { url: "", data: undefined };
}
export const FetchRequest = {
    $type: "devvit.plugin.http.FetchRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.data !== undefined) {
            RequestData.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFetchRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = RequestData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            data: isSet(object.data) ? RequestData.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.data !== undefined) {
            obj.data = RequestData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return FetchRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFetchRequest();
        message.url = object.url ?? "";
        message.data = (object.data !== undefined && object.data !== null)
            ? RequestData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(FetchRequest.$type, FetchRequest);
function createBaseRequestData() {
    return { method: "", headers: {}, body: new Uint8Array(0) };
}
export const RequestData = {
    $type: "devvit.plugin.http.RequestData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.method !== "") {
            writer.uint32(10).string(message.method);
        }
        Object.entries(message.headers).forEach(([key, value]) => {
            RequestData_HeadersEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.body.length !== 0) {
            writer.uint32(26).bytes(message.body);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.method = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = RequestData_HeadersEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.headers[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.body = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            method: isSet(object.method) ? globalThis.String(object.method) : "",
            headers: isObject(object.headers)
                ? Object.entries(object.headers).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
            body: isSet(object.body) ? bytesFromBase64(object.body) : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.method !== "") {
            obj.method = message.method;
        }
        if (message.headers) {
            const entries = Object.entries(message.headers);
            if (entries.length > 0) {
                obj.headers = {};
                entries.forEach(([k, v]) => {
                    obj.headers[k] = v;
                });
            }
        }
        if (message.body.length !== 0) {
            obj.body = base64FromBytes(message.body);
        }
        return obj;
    },
    create(base) {
        return RequestData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRequestData();
        message.method = object.method ?? "";
        message.headers = Object.entries(object.headers ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.body = object.body ?? new Uint8Array(0);
        return message;
    },
};
messageTypeRegistry.set(RequestData.$type, RequestData);
function createBaseRequestData_HeadersEntry() {
    return { key: "", value: "" };
}
export const RequestData_HeadersEntry = {
    $type: "devvit.plugin.http.RequestData.HeadersEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequestData_HeadersEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return RequestData_HeadersEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRequestData_HeadersEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
messageTypeRegistry.set(RequestData_HeadersEntry.$type, RequestData_HeadersEntry);
function createBaseFetchResponse() {
    return { url: "", body: new Uint8Array(0), status: 0, headers: {} };
}
export const FetchResponse = {
    $type: "devvit.plugin.http.FetchResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.body.length !== 0) {
            writer.uint32(18).bytes(message.body);
        }
        if (message.status !== 0) {
            writer.uint32(24).int32(message.status);
        }
        Object.entries(message.headers).forEach(([key, value]) => {
            FetchResponse_HeadersEntry.encode({ key: key, value }, writer.uint32(34).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFetchResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.body = reader.bytes();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.status = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    const entry4 = FetchResponse_HeadersEntry.decode(reader, reader.uint32());
                    if (entry4.value !== undefined) {
                        message.headers[entry4.key] = entry4.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            body: isSet(object.body) ? bytesFromBase64(object.body) : new Uint8Array(0),
            status: isSet(object.status) ? globalThis.Number(object.status) : 0,
            headers: isObject(object.headers)
                ? Object.entries(object.headers).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.body.length !== 0) {
            obj.body = base64FromBytes(message.body);
        }
        if (message.status !== 0) {
            obj.status = Math.round(message.status);
        }
        if (message.headers) {
            const entries = Object.entries(message.headers);
            if (entries.length > 0) {
                obj.headers = {};
                entries.forEach(([k, v]) => {
                    obj.headers[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return FetchResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFetchResponse();
        message.url = object.url ?? "";
        message.body = object.body ?? new Uint8Array(0);
        message.status = object.status ?? 0;
        message.headers = Object.entries(object.headers ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
messageTypeRegistry.set(FetchResponse.$type, FetchResponse);
function createBaseFetchResponse_HeadersEntry() {
    return { key: "", value: "" };
}
export const FetchResponse_HeadersEntry = {
    $type: "devvit.plugin.http.FetchResponse.HeadersEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFetchResponse_HeadersEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return FetchResponse_HeadersEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFetchResponse_HeadersEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
messageTypeRegistry.set(FetchResponse_HeadersEntry.$type, FetchResponse_HeadersEntry);
export const HTTPServiceName = "devvit.plugin.http.HTTP";
export class HTTPClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || HTTPServiceName;
        this.rpc = rpc;
        this.Fetch = this.Fetch.bind(this);
    }
    Fetch(request, metadata) {
        const data = FetchRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Fetch", data, metadata);
        return promise.then((data) => FetchResponse.decode(_m0.Reader.create(data)));
    }
}
export const HTTPDefinition = {
    name: "HTTP",
    fullName: "devvit.plugin.http.HTTP",
    methods: {
        fetch: {
            name: "Fetch",
            requestType: FetchRequest,
            requestStream: false,
            responseType: FetchResponse,
            responseStream: false,
            options: {},
        },
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
